import React from "react";
import Sidebar from "../../components/header/Sidebar";
import Hero from "../../components/slider/Hero";
import About from "../../components/about/About";
import Service from "../../components/service/Service";
import Portfolio from "../../components/portfolio/Portfolio";
import Testimonial from "../../components/testimonial/Testimonial";
import Blog from "../../components/blog/Blog";
import Contact from "../../components/Contact";
import Address from "../../components/Address";
import Map from "../../components/Map";
import CookieConsent from "react-cookie-consent";

const HomeLight = () => {
  document.body.classList.add("light");
  return (
    <div className="home-light edina_tm_mainpart">
      {/* https://openbase.com/js/react-cookie-consent */}
      <CookieConsent
        location="bottom"
        buttonText="Accetta"
        declineButtonText="Rifiuta"
        cookieName="avvocatoMariaMacrinoCookie"
        style={{ background: "#2B373B" }}
        buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
        expires={150}
      >
        Gentile Utente, questo sito utilizza i cookies per rendere sicura e migliore la Sua esperienza di consultazione delle sito web. Se si prosegue nella navigazione del sito si assume che Lei abbia preso visione delle indicazioni riportate sull'uso dei cookies e le abbia accettate.{" "}
        {<span style={{ fontSize: "15px" }}><a href="/privacy-policy" style={{ color: 'red' }}>{" "}leggi la "privacy e cookie policy"</a></span>}
      </CookieConsent>
      <Sidebar />
      {/* End Header */}
      <Hero />
      {/* End Hero */}
      <About />
      {/* End Hero */}

      <div className="edina_tm_services" id="service">
        <div className="container">
          <div className="edina_tm_title">
            <h3>Competenze</h3>
            <p>
              L’Avv. Maria Macrino offre solida preparazione accademica e formazione continua negli ambiti del diritto di cui si occupa.
              <br />
              Nel rispetto della legge e della deontologia forense, l’Avvocato si impegna duramente per difendere i diritti del Cliente e quando è possibile, promuove il compromesso sui conflitti, costruendo ponti verso le controparti per arrivare ad una soluzione condivisa ed equa in tempi brevi.
            </p>
            <br />
            {/* <p>Ogni Icona: un simbolo, l’ambito e la descrizione breve</p> */}
          </div>
          {/* End edian_tm_title */}
          <Service />
        </div>
      </div>
      {/* End Services */}

      {/*<div className="edina_tm_portfolio" id="portfolio">
        <div className="container">
          <div className="edina_tm_title">
            <h3>Portfolio</h3>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris
              ipsum sit nibh amet egestas tellus.
            </p>
          </div>
          <Portfolio />
        </div>
      </div>
       End Portfolio */}

      <div className="edina_tm_testimonials" id="testimonial">
        <div className="container">
          <div className="edina_tm_title">
            <h3>L'avvocato risponde</h3>
            <p>
            </p>
          </div>
          {/* End edian_tm_title */}
          <div className="list ">
            <ul>
              <p className="p-8">A breve alcuni articoli...</p>
              {/* <Testimonial /> */}
            </ul>
          </div>
        </div>
      </div>
      {/* End Testimonial */}

      <div className="edina_tm_news" id="blog">
        <div className="container">
          <div className="edina_tm_title">
            <h3>Consulenza legale on line</h3>
            <p
              className="text"
              style={{ textAlign: "left", maxWidth: '100%' }}
            >
              Al fine di soddisfare ogni esigenza della clientela, lo Studio Legale Avv. Maria Macrino mette a disposizione dei propri Clienti un servizio di consulenza legale on line rendendosi una risorsa immediatamente fruibile.
              <br /><br />
              Per ricevere una consulenza legale on line, invia una e-mail all’indirizzo m.macrino@avvocatomacrino.it e riceverai entro 24 ore lavorative una prima risposta.
              <br /><br />
              Il servizio è sempre attivo dal lunedì al venerdì, dalle ore 9.00 alle ore 18.00.
              <br />
              <b>La prima consulenza è gratuita.</b>
            </p>
          </div>
          {/* End edian_tm_title 
          <Blog />*/}
        </div>
      </div>
      {/* End Blog */}

      <div className="edina_tm_contact" id="contact">
        <div className="container">
          <div className="edina_tm_title">
            <h3>Contatti</h3>
            <p>
              Fissa subito un appuntamento presso lo Studio Legale
            </p>
            <p>Avv. Maria Macrino o richiedi una consulenza on line.
            </p>
          </div>
          <div className="extra_info">
            <Address />
          </div>
          {/* End Address Info */}
          <div className="mainpart">
            <div
              className="left"
              data-aos="fade-right"
              data-aos-duration="1200"
              data-aos-delay="300"
            >
              <h7>
                <p>
                  Per ricevere una <b>consulenza legale on line</b>, compila i campi di seguito e riceverai entro 24 ore lavorative una prima risposta
                  {/*   <br />
                  <span> design work or partnerships.</span>*/}
                </p>
              </h7>
              <br />
              {/* End title */}
              <div className="fields">
                <Contact />
              </div>
              {/* End Contact Form */}
            </div>
            <div
              className="right"
              data-aos="fade-right"
              data-aos-duration="1200"
              data-aos-delay="400"
            >
              <Map />
            </div>
            {/* End Map */}
          </div>
        </div>
      </div>
      {/* /CONTACT */}
    </div>
  );
};

export default HomeLight;
